import jaLocale from "element-ui/lib/locale/lang/ja";
import enLocale from "element-ui/lib/locale/lang/en";
import koLocale from "element-ui/lib/locale/lang/ko";
import zhTWLocale from "element-ui/lib/locale/lang/zh-TW";
import zhCNLocale from "element-ui/lib/locale/lang/zh-CN";

const locales = {
  ja: {
    ...require('@/assets/localize/localize-ja.json'),
    ...jaLocale
  },
  en: {
    ...require('@/assets/localize/localize-en.json'),
    ...enLocale
  },
    ko: {
    ...require('@/assets/localize/localize-ko.json'),
    ...koLocale
  },
  'zh-tw': {
    ...require('@/assets/localize/localize-zh-tw.json'),
    ...zhTWLocale
  },
  'zh-cn': {
    ...require('@/assets/localize/localize-zh-cn.json'),
    ...zhCNLocale
  }
};

const DEFAULT_LANG = navigator.language;

const i18nConfig = {
  locale: DEFAULT_LANG,
  legacy: false,
  fallbackLocale: ['ja'],
  messages: locales,
}

export default i18nConfig
